module.exports = __webpack_public_path__ + "img/project_icon_six.cadf2eed.png";